var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:_vm.navSectionClassObject},[_c('span',{staticClass:"nav-separator"}),_vm._v(" "),(!!_vm.showTitle)?_c('div',{staticClass:"nav-section-title headline-font"},[_vm._v(_vm._s(_vm.title))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }